export default __webpack_public_path__ + "static/cd_raw_3-9622dab92ea784b078801ff1a4debe44.jpg";